import parseCardProperty from './parseCardProperty';
import setCardDetailsOnItem from '../actions/setCardDetailsOnItem';
import { CardDetails } from 'owa-actionable-message';
import { ClientItem } from 'owa-mail-store';
import getItem from 'owa-mail-store/lib/services/getItem';
import checkIfResponseSuccess from 'owa-mail-store/lib/services/utils/checkIfResponseSuccess';
import getExtendedPropertyValue from 'owa-mail-store/lib/utils/getExtendedPropertyValue';
import ExtendedPropertyUri from 'owa-service/lib/contract/ExtendedPropertyUri';
import ItemInfoResponseMessage from 'owa-service/lib/contract/ItemInfoResponseMessage';
import itemResponseShape from 'owa-service/lib/factory/itemResponseShape';
import { getExtendedPropertyUri } from 'owa-service/lib/Utils';
import { trace } from 'owa-trace';

const MESSAGE_CARD_PROPERTY_NAME = 'IOpenTypedFacet.Com.Microsoft.Graph.MessageCard';
const PROPERTY_SET_GUID = 'E550B918-9859-47B9-8095-97E4E72F1926';

export default async function initCardDetailsOnItem(item: ClientItem) {
    const cardDetails = (await loadCardDetailsForItem(item)) || [];
    if (!item.adaptiveCardDetails || item.adaptiveCardDetails.length === 0) {
        trace.info('[MessageCardDebug] initCardDetailsOnItem: setting card details on item');
        setCardDetailsOnItem(item, cardDetails);
    } else {
        trace.info('[MessageCardDebug] initCardDetailsOnItem: not replacing existing details');
    }
}

async function loadCardDetailsForItem(item: ClientItem): Promise<CardDetails[]> {
    try {
        const itemShape = itemResponseShape({
            BaseShape: 'IdOnly',
            AdditionalProperties: [getExtendedPropertyUriForMessageCard()],
        });

        // VSO 30283: Use null for shape name instead of ItemPart.
        // ItemPart is meant for GCI and hurts performance when used with GetItem.
        const response = await getItem([item.ItemId.Id], itemShape, null);
        if (checkIfResponseSuccess(response[0])) {
            const responseMessage = response[0] as ItemInfoResponseMessage;
            const message = responseMessage.Items[0];
            const extendedPropertyValue = getExtendedPropertyValue(
                message,
                null /* tag */,
                MESSAGE_CARD_PROPERTY_NAME
            );
            if (extendedPropertyValue) {
                return await parseCardProperty(extendedPropertyValue);
            }
        }
    } catch (e) {
        // On a network error we just won't have a card for this item
    }

    trace.info('[loadCardDetailsForItem] extendedProperty could not be retrieved');
    return null;
}

function getExtendedPropertyUriForMessageCard(): ExtendedPropertyUri {
    return getExtendedPropertyUri(PROPERTY_SET_GUID, MESSAGE_CARD_PROPERTY_NAME, 'String');
}
